<template>
  <div id="app" class="container-fluid no-padding">
    <router-view></router-view>
    <!--
    <div id="box-cookie" class="col-xs-24" :style="[infoCookie ? {'height': '0px'} : {}]">
      <p class="testo" v-html="$t('cookie')"></p>
      <el-button @click="setCookie">{{$t('btn_continua')}}</el-button>
    </div>
    -->
  </div>
</template>

<script>
  export default {
    name: 'App',
    i18n: {
      messages: {
        it_IT: {
          btn_continua: 'CONTINUA',
          cookie: 'Questo sito utilizza cookie tecnici e cookie di terze parti per migliorare la tua esperienza di navigazione. Se vuoi saperne di più o negare il consenso ad alcuni cookie <a href="static/docs/Cookie_it_IT.pdf" target="_blank">clicca qui</a>. Chiudendo questo banner o continuando la navigazione sulsito acconsenti all’utilizzo dei cookie.'
        },
        en_GB: {
          btn_continua: 'CONTINUE',
          cookie: 'This site uses technical cookies and third-party cookies to improve your browsing experience. If you want to learn more or opt out of some cookies <a href="static/docs/Cookie_it_IT.pdf" target="_blank">click here</a>. By closing this banner or continuing browsing the site, you consent to the use of cookies.'
        },
        es_ES: {
          btn_continua: 'CONTINUAR',
          cookie: 'Este sitio utiliza cookies técnicas y cookies de terceros para mejorar su experiencia de navegación. Si desea obtener más información o cancelar algunas cookies <a href="static/docs/Cookie_it_IT.pdf" target="_blank">haga clic aquí</a>. Al cerrar este banner o continuar navegando por el sitio, usted acepta el uso de cookies.'
        },
        fr_FR: {
          btn_continua: 'CONTINUE',
          cookie: 'Ce site utilise des cookies techniques et des cookies tiers pour améliorer votre expérience de navigation. Si vous voulez en savoir plus ou refuser certains cookies <a href="static/docs/Cookie_it_IT.pdf" target="_blank">cliquez ici</a>. En fermant cette bannière ou en continuant à naviguer sur le site, vous consentez à l\'utilisation de cookies.'
        },
        de_DE: {
          btn_continua: 'WEITER',
          cookie: 'Diese Website verwendet technische Cookies und Cookies von Drittanbietern, um Ihre Browser-Erfahrung zu verbessern. Wenn Sie mehr erfahren oder einige Cookies ablehnen möchten <a href="static/docs/Cookie_it_IT.pdf" target="_blank">klick hier</a>. Indem Sie dieses Banner schließen oder die Seite weiter durchsuchen, stimmen Sie der Verwendung von Cookies zu.'
        }
      }
    }
    ,
    data () {
      return {
        infoCookie: false
      }
    },
    methods: {
      setCookie: function () {
        localStorage.setItem('cookie', 'true')
        this.infoCookie = true
      }
    },
    mounted: function () {
      if (localStorage.getItem('cookie') !== null) {
        this.infoCookie = true
      }
    }
  }
</script>

<style lang="less">
  @import "./assets/less/general.less";
  @import './assets/less/general-element.less';

  .no-padding {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .row-custom {
    margin-left: 0px;
    margin-right: 0px;
  }

  .padding {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  .margin {
    margin-left: 15px !important;
    margin-right: 15px !important;
  }

  .pointer:hover {
    cursor: pointer;
  }

  body {
    margin: 0px;
    height: 100%;
    background-color: #eef4f9;
  }

  .el-popover {
    div {
      div {
        .set-font(@color: @textTable);
        line-height: 30px;
      }
    }
  }

  .el-input-number {
    width: 100%;
    line-height: 22px;
  }

  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue